import { render } from "./AlertConfigForm.vue?vue&type=template&id=54aa7c3b&scoped=true"
import script from "./AlertConfigForm.vue?vue&type=script&lang=js"
export * from "./AlertConfigForm.vue?vue&type=script&lang=js"

import "./AlertConfigForm.vue?vue&type=style&index=0&id=54aa7c3b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54aa7c3b"]])

export default __exports__